import type { IconNode } from '../types';

/**
 * @name bowling
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNOSAxMGguMDEiIC8+CiAgPHBhdGggZD0iTTYgMTNoLjAxIiAvPgogIDxwYXRoIGQ9Ik0xMCAxNGguMDEiIC8+CiAgPHBhdGggZD0iTTExLjA5IDYuMDdhOCA4IDAgMSAwIC4zMiAxNS44MSIgLz4KICA8cGF0aCBkPSJNMTYgOWg0IiAvPgogIDxwYXRoIGQ9Ik0xNSA1YzAgMS41IDEgMiAxIDQgMCAyLjUtMiA0LjUtMiA3IDAgMi42IDEuOSA2IDEuOSA2SDIwczItMy40IDItNmMwLTIuNS0yLTQuNS0yLTcgMC0yIDEtMi41IDEtNGEzIDMgMCAxIDAtNiAwIiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/bowling
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const bowling: IconNode = [
  ['path', { d: 'M9 10h.01', key: 'qbtxuw' }],
  ['path', { d: 'M6 13h.01', key: '11u803' }],
  ['path', { d: 'M10 14h.01', key: 'ssrbsk' }],
  ['path', { d: 'M11.09 6.07a8 8 0 1 0 .32 15.81', key: 'awu32r' }],
  ['path', { d: 'M16 9h4', key: '6lmw2d' }],
  [
    'path',
    {
      d: 'M15 5c0 1.5 1 2 1 4 0 2.5-2 4.5-2 7 0 2.6 1.9 6 1.9 6H20s2-3.4 2-6c0-2.5-2-4.5-2-7 0-2 1-2.5 1-4a3 3 0 1 0-6 0',
      key: 'slqao2',
    },
  ],
];

export default bowling;
